
<script>import { Σ } from "../../common/clsx/index";
import { setContext } from "../../common/svelte/index";
import { writable } from "svelte/store";
export let gutter = 0;
export let className = "";
const gutterStore = writable(gutter);
setContext("gutter", gutterStore);

$: {
  $gutterStore = gutter;
}

const style = Σ("el-row", {
  [className]: Boolean(className)
});</script>


<div class={style}>
        <slot />
    </div>


<style>

</style>